import { createSlice } from '@reduxjs/toolkit';

/**
 * Regression Dashboard Slice
 * Manages state for filters and selections in the Regression Dashboard.
 *
 * `filters` is a dynamic map keyed by the filter identifiers returned in the
 * project-scoped filters API (e.g. `appOrIntegration`, `testCaseType`, ...).
 * The dashboard renders whichever keys the backend declares in
 * `availableFilters`, so the shape here is intentionally open-ended.
 */

const initialState = {
  selectedProjects: [], // Array of selected project codes (backend `projectKey`)
  filters: {}, // { [filterKey]: string[] }
  lastUpdated: null,
};

const regressionDashboardSlice = createSlice({
  name: 'regressionDashboard',
  initialState,
  reducers: {
    setSelectedProjects: (state, action) => {
      state.selectedProjects = action.payload;
      state.lastUpdated = new Date().toISOString();
    },
    clearSelectedProjects: (state) => {
      state.selectedProjects = [];
      state.lastUpdated = new Date().toISOString();
    },
    setFilter: (state, action) => {
      const { filterKey, value } = action.payload;
      state.filters[filterKey] = value;
      state.lastUpdated = new Date().toISOString();
    },
    clearFilter: (state, action) => {
      const { filterKey } = action.payload;
      state.filters[filterKey] = [];
      state.lastUpdated = new Date().toISOString();
    },
    clearAllFilters: (state) => {
      state.filters = {};
      state.lastUpdated = new Date().toISOString();
    },
    resetDashboard: (state) => {
      state.selectedProjects = [];
      state.filters = {};
      state.lastUpdated = new Date().toISOString();
    },
  },
});

export const {
  setSelectedProjects,
  clearSelectedProjects,
  setFilter,
  clearFilter,
  clearAllFilters,
  resetDashboard,
} = regressionDashboardSlice.actions;

export default regressionDashboardSlice.reducer;
